/* eslint-disable no-param-reassign */
import { cast } from 'mobx-state-tree';
import type { ILayoutModel } from './model';

export default (self: ILayoutModel) => ({
  setBreakpoint: (breakpoint, layout) => {
    self[breakpoint] = cast(layout);
  }
});
